class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle?.querySelector('summary');
    this.content = this.summary?.nextElementSibling;
    this._hoverTimeout = null;

    if (!this.mainDetailsToggle) return;

    // Add event listeners for hover behavior on both summary and content
    this.summary?.addEventListener('mouseenter', this.clearHoverTimeout.bind(this));
    this.summary?.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    this.content?.addEventListener('mouseenter', this.clearHoverTimeout.bind(this));
    this.content?.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
  }

  openOnHover() {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', false);
      setTimeout(() => {
        this.onToggle();
      }, 100);
    }
  }

  clearHoverTimeout() {
    if (this._hoverTimeout) {
      clearTimeout(this._hoverTimeout);
      this._hoverTimeout = null;
    }
    this.openOnHover();
  }

  handleMouseLeave() {
    this._hoverTimeout = setTimeout(() => {
      this.close();
    }, 100);
  }

  onToggle() {
    if (!this.animations && this.content) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations?.forEach((animation) => animation.play());
    } else {
      this.animations?.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
